export default __webpack_public_path__ + "static/media/userjoined.1ed6293e.mp3";